module.exports = __webpack_public_path__ + "static/media/april-win.c81531fd.png";